import React, {useEffect, useRef, useState} from "react";
import ZoomVideo from '@zoom/videosdk'
import {useEffectOnce} from "../hooks/useEffectOnce";
import * as UserService from "../api/UserService";
import screenStyle from "./CallScreen.module.css"
import Draggable from 'react-draggable';
import style from "../pages/table/GameField.module.css";
import OpenWithOutlinedIcon from "@mui/icons-material/OpenWithOutlined";
import HeightIcon from '@mui/icons-material/Height';
import {deepPurple} from "@mui/material/colors";
import {trySetTimeout} from "../hooks/trySetTiemout";

function ZoomCallScreen(props) {
    const client = ZoomVideo.createClient()

    const [isMuted, setIsMuted] = useState(true)
    const [videoOff, setVideoOff] = useState(false)
    const [canvasWidth, setCanvasWidth] = useState(0)
    const [canvasHeight, setCanvasHeight] = useState(0)
    const [audioStarted, setAudioStarted] = useState(false)

    const [audioDecoded, setAudioDecoded] = useState(false)
    const [audioEncoded, setAudioEncoded] = useState(false)

    const stream = useRef()
    const drugableNodeRef = useRef()

    let isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
        navigator.userAgent &&
        navigator.userAgent.indexOf('CriOS') === -1 &&
        navigator.userAgent.indexOf('FxiOS') === -1;

    function flipDirection() {
        props.setHorizontal(!props.isHorizontal)
    }

    function startVideo() {
        const zoomVideoOptions = {
                mirrored: true,
                videoElement: document.querySelector('#my-self-view-video'),
                captureHeight: 282,
                captureWidth: 500,
            }

        if (stream.current.isRenderSelfViewWithVideoElement()) {
            stream.current
                .startVideo(zoomVideoOptions)
                .then(() => {
                    document.querySelector('#my-self-view-video').height = "141"
                    document.querySelector('#my-self-view-canvas').height = "0"
                    document.querySelector('#my-self-view-canvas').width = "0"
                    stream.current.updateVideoCanvasDimension(
                        document.querySelector('#my-self-view-canvas'),
                        0,
                        0
                    )

                    if (typeof SharedArrayBuffer === 'function' && window.crossOriginIsolated) {
                        try {
                            stream.current.updateVirtualBackgroundImage("blur")
                        } catch (error) {
                            window.alert("Background blur disabled " + JSON.stringify(error))
                        }
                    }

                    setVideoOff(false)
                })
                .catch((error) => {
                    window.alert("Zoom video failed " + JSON.stringify(error))
                })

        } else {
            stream.current
                .startVideo(zoomVideoOptions)
                .then(() => {
                    stream.current
                        .renderVideo(
                            document.querySelector('#my-self-view-canvas'),
                            client.getCurrentUserInfo().userId, 250, 141, 0, 0, 2)
                        .then(() => {
                            document.querySelector('#my-self-view-video').height = "0px"
                            document.querySelector('#my-self-view-video').width = "0px"
                            if (typeof SharedArrayBuffer === 'function' && window.crossOriginIsolated) {
                                try {
                                    stream.current.updateVirtualBackgroundImage("blur")
                                } catch (error) {
                                    window.alert("Background blur disabled " + JSON.stringify(error))
                                }
                            }
                            setVideoOff(false)
                        })
                        .catch((error) => {
                            window.alert("Zoom canvas video failed " + JSON.stringify(error))
                        })
                })
                .catch((error) => {
                    window.alert("Zoom canvas video failed " + JSON.stringify(error))
                })
        }
    }

    async function render_all_remote() {
        let participants = client.getAllUser()

        participants.sort((a,b) => a.userId - b.userId)
        let remote_count = 0
        if (stream.current === undefined) {
            stream.current = client.getMediaStream()
        }

        let remotes = participants.length > 0 ? participants.length - 1 : 0

        let newCanvasWidth = 1
        let newCanvasHeight = 1

        if (props.isHorizontal) {
            newCanvasHeight = 141
            newCanvasWidth = remotes * 250 + 2
        } else if (props.isHorizontal === false) {
            newCanvasHeight = remotes * 141 + 2
            newCanvasWidth = 250
        }

        try {
            document.querySelector('#participant-videos-canvas').width = newCanvasWidth
            document.querySelector('#participant-videos-canvas').height = newCanvasHeight
        } catch (error) {
            await stream.current.updateVideoCanvasDimension(
                document.querySelector('#participant-videos-canvas'),
                newCanvasWidth,
                newCanvasHeight
            ).catch(error => {
                window.alert("Error update canvas: " + JSON.stringify(error) + "\n Try again")
            })
        }

        if (canvasWidth !== newCanvasWidth || canvasHeight !== newCanvasHeight) {
            await new Promise(r => trySetTimeout(r, 500));
            setCanvasWidth(newCanvasWidth)
            setCanvasHeight(newCanvasHeight)
        }



        await Promise.all(
            participants.map(async (participant) => {
                if (participant.userId === client.getCurrentUserInfo()?.userId) {
                    return
                }
                await stream.current.stopRenderVideo(
                    document.querySelector('#participant-videos-canvas'),
                    participant.userId,
                )
            })
        ).catch(error => {
            window.alert("Error derender: " + JSON.stringify(error) + "\n Try again")
        })



        await Promise.all(
            participants.map(async (participant) => {
                if (participant.userId === client.getCurrentUserInfo().userId) {
                    return
                }

                remote_count = remote_count + 1
                if (!participant.bVideoOn) {
                    return
                }

                let x ,y

                if (props.isHorizontal) {
                    x = 250 * (remote_count - 1) + 2
                    y = 0
                } else {
                    x = 0
                    y = 141 * (remote_count - 1) + 2
                }

                await stream.current.renderVideo(
                    document.querySelector('#participant-videos-canvas'),
                    participant.userId,
                    250,
                    141,
                    x,
                    y,
                    2
                ).catch((error) => {
                    window.alert("Zoom video failed 2 " + JSON.stringify(error))
                })
                }
            )
        ).catch(error => {
            window.alert("Error render: " + JSON.stringify(error) + "\n Try again")
        })
    }


    client.on('peer-video-state-change', async (payload) => {
        if (payload.action === 'Start' && stream.current) {
            await render_all_remote()
        } else if (payload.action === 'Stop' && stream.current) {
            stream.current.stopRenderVideo(
                document.querySelector('#participant-videos-canvas'),
                payload.userId,
            )
        }

    })

    client.on('user-removed', async (payload) => {
        if (payload.length > 0) {
            await stream.current?.stopRenderVideo(
                document.querySelector('#participant-videos-canvas'),
                payload[0].userId,
            )
            await new Promise(r => trySetTimeout(r, 500));
            await render_all_remote()
        }
    })

    client.on("media-sdk-change", (payload) => {
        const { action, type, result } = payload;
        if (type === "audio" && result === "success") {
            // encode for sending audio stream (talk)
            if (action === "encode") {
                setAudioEncoded(true)
            }
            // decode for receiving audio stream (hear)
            else if (action === "decode") {
                setAudioDecoded(true)
            }
        }
    });

    function onZoomAuth(response) {
        client.join(props.gameState.id, response.token, props.userName).then(() => {
            stream.current = client.getMediaStream()
            startVideo()
            stream.current.startAudio({autoStartAudioInSafari: true})
                .then(() => {
                    setAudioStarted(true)
                    setIsMuted(false)
                })
                .catch((error1) => {
                    stream.current.startAudio().then(() => {
                        setAudioStarted(true)
                        setIsMuted(false)
                    }).catch((error2) => {
                        setAudioStarted(false)
                    })
                })
        }).catch((error) => {
            if (error.reason === "duplicated operation") {
                stream.current = client.getMediaStream()
                stopVideoWithRetry(stream.current, startVideo, 10, 100)
                startVideo()
                stream.current.startAudio({autoStartAudioInSafari: true}).then(() => {
                    setAudioStarted(true)
                    setIsMuted(false)
                }).catch((error) => {
                    stream.current.startAudio().then(() => {
                        setAudioStarted(true)
                        setIsMuted(false)
                    }).catch((error2) => {
                        setAudioStarted(false)
                    })
                })
            } else {
                window.alert("Client join error: " + JSON.stringify(error))
                close()
            }
        })
    }

    function close() {
        client.leave().then(() => {
            props.onStop()
        }).catch(error => window.alert("Video Close failed: " + JSON.stringify(error)))
    }

    function wait(delay){
        return new Promise((resolve) => trySetTimeout(resolve, delay));
    }

    function stopVideoWithRetry(stream, callback, attempts, delay) {

        stream.stopVideo().then(callback)
            .catch(error => {
                const attemptsLeft = attempts - 1;
                if (!attemptsLeft) {
                    console.error("Failed to stop video with retry " + JSON.stringify(error), error)
                    window.alert("Не вдалося зупинити відео")
                }
                wait(delay).then(() => stopVideoWithRetry(stream, callback, attemptsLeft, delay))
            })
    }

    function pauseVideo() {

        if (stream.current === undefined) {
            stream.current = client.getMediaStream()

        }
        if (!videoOff) {
            const stopRenderFunc = () => {
                try {
                    setVideoOff(true)
                    let element = document.querySelector('#my-self-view-canvas')
                    if (stream.current.isRenderSelfViewWithVideoElement()) {
                        element = document.querySelector('#my-self-view-video')
                    }
                    stream.current.stopRenderVideo(element, client.getCurrentUserInfo()?.userId)
                } catch (e) {
                    console.error("Failed to pause video" + JSON.stringify(e), e)
                    window.alert("Виникла помилка обробки відео. Спробуйте ще раз або перезавантажте сторінку")
                }

            }
            stopVideoWithRetry(stream.current, stopRenderFunc, 100, 100)
        } else {
            startVideo()
        }

    }

    async function mute() {
        if (stream.current === undefined) {
            stream.current = client.getMediaStream()
        }

        if (!audioStarted) {

            if (isSafari && (!audioDecoded || !audioEncoded)) {
                const sleepNow = (delay) => new Promise((resolve) => trySetTimeout(resolve, delay))
                let retryCounter = 0
                while (retryCounter < 30 && (!audioDecoded || !audioEncoded)) {
                    await sleepNow(300)
                }
            }

            stream.current.startAudio()
                .then(() => {
                    setAudioStarted(true)
                }).catch((error) => {
                    window.alert("StartAudio feiled " + JSON.stringify(error))
            })
        }

        if (isMuted) {
            stream.current.unmuteAudio().then(() => {
                setIsMuted(false)
            }).catch(error => window.alert("Microphone error, try again"))
        } else {
            stream.current.muteAudio().then(() => {
                setIsMuted(true)
            }).catch(error => window.alert("Microphone error, try again"))
        }
    }


    useEffectOnce(() => {
        client.init('en-US', 'Global', { patchJsMedia: true, enforceMultipleVideos: true}).then(() => {
            UserService.getZoomAuthToken(props.gameState.id, onZoomAuth, () => {
                window.alert("Failed to connect to Zoom")
            })
        }).catch(e => {
            window.alert(JSON.stringify(e))
        })
    })

    useEffect(() => {
        render_all_remote()
    }, [props.isHorizontal])

    return (
        <Draggable
            nodeRef={drugableNodeRef}
            axis="both"
            handle=".handle"
            defaultPosition={{x: -400, y: 200}}
            scale={1}
            bounds="#boundaries"
        >
            <div ref={drugableNodeRef} style={{display: "flex", flexDirection: "column", width: 0}}>
                <div className={screenStyle.zoomVideoDraggableComponent}>
                    <div className={style.zoomHandle}>
                        <OpenWithOutlinedIcon sx={{ color: deepPurple[50], cursor: "all-scroll"}} className="handle"></OpenWithOutlinedIcon>
                        <HeightIcon sx={{ color: deepPurple[50] }} onClick={flipDirection} className={props.isHorizontal ? screenStyle.flipped0 :screenStyle.flipped90}></HeightIcon>


                        </div>
                    <div className={props.isHorizontal? screenStyle.zoomVideoGroupHor : screenStyle.zoomVideoGroupVert}>
                        <div className={screenStyle.zoomVideo}>
                            <div className={screenStyle.zoomControls}>
                                <div className={screenStyle.finishCall} onClick={close}></div>

                                <div className={screenStyle.subcontrols}>
                                    <div className={isMuted ? screenStyle.mute : screenStyle.unMute} onClick={mute}></div>
                                    <div className={videoOff ? screenStyle.videoOff : screenStyle.videoOn}
                                         onClick={pauseVideo}></div>
                                </div>

                            </div>
                            <video id="my-self-view-video" width="250" height="0"></video>
                            <canvas id="my-self-view-canvas" width="250" height="141"/>

                        </div>
                        <div className={props.isHorizontal ? screenStyle.zoomRemoteVideoHor : screenStyle.zoomRemoteVideoVert}>
                            <canvas id="participant-videos-canvas" width="0" height="0"/>
                        </div>
                    </div>
                </div>
            </div>
        </Draggable>
    )

}

export default ZoomCallScreen